export default "__VITE_ASSET__CeydlLMJ__"